import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterService } from './common/master.service';
import { IApiResponse } from '../interface/api-response.interface';
import { Global } from '../data/global';
import { BaseUrlEnum, getBaseURL } from './common/base-url-resolver.util';

@Injectable({
  providedIn: 'root',
})
export class CmsService {
  private masterService = inject(MasterService);
  public skeletonLoader: boolean = false;
  private platformId = inject<Object>(PLATFORM_ID);


  // html api...................
  getPageInfo(masterId: number, languageId?: number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`html/GetPageInfo?clientId=${Global.ClientID}&masterId=${masterId}&&languageId=${languageId ?? Global.LanguageID}`);
  }

  ListofContent(masterId: number, cTypeId: number, languageId?: number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`html/ListofContent?masterId=${masterId}&cTypeId=${cTypeId}&languageId=${languageId ?? Global.LanguageID}`);
  }

  SingleContent(masterId: number, contentId:number, cTypeId: number, languageId?: number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`html/SingleContent?masterId=${masterId}&contentId=${contentId}&cTypeId=${cTypeId}&languageId=${languageId ?? Global.LanguageID}`);
  }


  // blog api...................
  getAllBlog(languageId:number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`blog/GetAllBlogs?clientId=${Global.ClientID}&languageId=${Global.LanguageID}`);
  }

  getBlogDetails(masterId : number, languageId : number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`blog/GetBlogDetails?masterId=${masterId}&languageId=${Global.LanguageID}`);
  }


  // general api...................
  getAllService(categoryId : number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`general/GetAllServices?clientId=${Global.ClientID}&categoryId=${categoryId}`);
  }

  getContents(serviceMasterId : number, languageId: number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`general/GetContents?serviceMasterId=${serviceMasterId}&languageId=${Global.LanguageID}`);
  }


  // gallery api...................
  getGalleries() : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`gallery/GetGalleries?clientId=${Global.ClientID}`);
  }
  getGalleryItems(galleryId : number) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`gallery/GetGalleryItems?clientId=${Global.ClientID}&galleryId=${galleryId}`);
  }


  // branch api...................
  getOffices(): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId,BaseUrlEnum.CMS),
      `branch/GetOffices?clientId=${Global.ClientID}`,
    );
  }

  openingHours(branchId: number): Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(
      getBaseURL(this.platformId,BaseUrlEnum.CMS),
      `branch/OpeningHours?branchId=${branchId}`,
    );
  }

  getTeam(deptId?: number): Observable<IApiResponse> {
    let url = `branch/GetTeam?clientId=${Global.ClientID}`;
    if (deptId) {
      url += `&deptId=${deptId}`;
    }
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),url);
  }


  // contact api...................
   getTestimonials() : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`contact/GetTestimonials?clientId=${Global.ClientID}`);
  }

  getContactSubjects(languageId : number = 1) : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`contact/GetContactSubjects?clientId=${Global.ClientID}&languageId=${Global.LanguageID}`);
  }

  saveMessage(data: any) : Observable<IApiResponse> {
    data.clientId=Global.ClientID
    return this.masterService.post<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`contact/SaveMessage`,data);
  }

   saveApplication(data: FormData) : Observable<IApiResponse> {
    data.append('clientId',String(Global.ClientID))
    data.append('clientName',String(Global.ClientName))
    return this.masterService.post<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`contact/SaveApplication`,data);
  }

  getSocialProfile() : Observable<IApiResponse> {
    return this.masterService.get<IApiResponse>(getBaseURL(this.platformId,BaseUrlEnum.CMS),`socialprofile/GetSocialProfileByClient?clientId=${Global.ClientID}`);
  }
}
